import React from 'react'

const RadioInput = ({ id, name, lable, value, checked, onChange }) => {
    return (
        <div >
            <input type="radio" className="btn-check " id={id} name={name} value={value} checked={checked}
                onChange={onChange} />
            <label className="btn radio-shadow" htmlFor={id}>{lable}</label>
        </div>
    )
}

export default RadioInput
